import React from 'react';
import {
  Dialog,
  Icon,
  IconButton,
  Icons,
  Stack,
  Typography,
  DialogTitle,
} from '@nextiva/next-ui-components';
import { Autom8tlyDialogProps } from 'interface/WizardV3';
import { useGetAutom8tlyUrl } from './WizardContextV3/useGetAutom8tlyUrl';

const dataTestId = 'PlatformAdminUI-Messaging-Autom8tlyDialog';
const Autom8tlyDialog = ({ open, handleCloseDialog }: Autom8tlyDialogProps) => {
  const autom8tlyResponse = useGetAutom8tlyUrl();
  const autom8tlyUrl = autom8tlyResponse.data?.autom8tlyBaseUrl;
  return (
    <Dialog
      data-testid={`${dataTestId}`}
      fullScreen
      open={open}
      onClose={handleCloseDialog}
    >
      <DialogTitle data-testid={`${dataTestId}-Title`} style={{ padding: 0 }}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="space-between"
          margin="12px 16px"
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="flex-start"
          >
            <IconButton
              aria-label="back-button"
              onClick={handleCloseDialog}
              data-testid={`${dataTestId}-Title-BackButton`}
            >
              <Icon icon={Icons.faArrowLeftSolid} size={16} />
            </IconButton>
            <Typography variant="h6" fontWeight={800} color="#0B1029">
              Business messaging registration
            </Typography>
          </Stack>
          <IconButton
            aria-label="close-button"
            onClick={handleCloseDialog}
            data-testid={`${dataTestId}-Title-CloseButton`}
          >
            <Icon icon={Icons.close} size={16} />
          </IconButton>
        </Stack>
      </DialogTitle>
      {autom8tlyUrl ? (
        <iframe
          src={`${autom8tlyUrl}`}
          width="100%"
          height="100%"
          title="Autom8tly Campaign Editor"
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
          allow="clipboard-read; clipboard-write; camera 'none'; microphone 'none'; geolocation 'none'; payment 'none'"
          referrerPolicy="strict-origin-when-cross-origin"
        />
      ) : (
        <div>Loading...</div>
      )}
    </Dialog>
  );
};

export default Autom8tlyDialog;
